/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Time } from './Time';
import {
    TimeFromJSON,
    TimeFromJSONTyped,
    TimeToJSON,
} from './Time';

/**
 * Representation of a special opening day
 * @export
 * @interface SpecialOpeningDay
 */
export interface SpecialOpeningDay {
    /**
     * 
     * @type {Time}
     * @memberof SpecialOpeningDay
     */
    openingTime?: Time;
    /**
     * 
     * @type {Time}
     * @memberof SpecialOpeningDay
     */
    closingTime?: Time;
    /**
     * Date of special opening day
     * @type {Date}
     * @memberof SpecialOpeningDay
     */
    date?: Date;
    /**
     * Text representation of the date of special opening day
     * @type {string}
     * @memberof SpecialOpeningDay
     */
    formattedDate?: string;
    /**
     * Flag stating if special opening day is closed
     * @type {boolean}
     * @memberof SpecialOpeningDay
     */
    closed?: boolean;
    /**
     * Name of the special opening day event
     * @type {string}
     * @memberof SpecialOpeningDay
     */
    name?: string;
    /**
     * Comment field
     * @type {string}
     * @memberof SpecialOpeningDay
     */
    comment?: string;
}

/**
 * Check if a given object implements the SpecialOpeningDay interface.
 */
export function instanceOfSpecialOpeningDay(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpecialOpeningDayFromJSON(json: any): SpecialOpeningDay {
    return SpecialOpeningDayFromJSONTyped(json, false);
}

export function SpecialOpeningDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialOpeningDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'openingTime': !exists(json, 'openingTime') ? undefined : TimeFromJSON(json['openingTime']),
        'closingTime': !exists(json, 'closingTime') ? undefined : TimeFromJSON(json['closingTime']),
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'formattedDate': !exists(json, 'formattedDate') ? undefined : json['formattedDate'],
        'closed': !exists(json, 'closed') ? undefined : json['closed'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function SpecialOpeningDayToJSON(value?: SpecialOpeningDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'openingTime': TimeToJSON(value.openingTime),
        'closingTime': TimeToJSON(value.closingTime),
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'formattedDate': value.formattedDate,
        'closed': value.closed,
        'name': value.name,
        'comment': value.comment,
    };
}

